/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllGetchkdUsers } from '../../../../../store/reducers/getchkdUser/getchkdUserAction';
import { Field, Form } from 'formik';
import { TextField } from 'formik-mui';

const AssetLocationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const dispatch = useDispatch();
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(getAllGetchkdUsers()).unwrap();

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);


    return (

        <>

            <Form>
                <Grid container spacing={4}>
                    {values.hasOwnProperty("getchkdid") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth error={Boolean(touched.getChkdID && errors.getChkdID)}>
                            <InputLabel htmlFor="outlined-status">Getchkd User</InputLabel>
                            <Select
                                value={values.getchkdid}
                                variant="outlined"
                                name="getchkdid"
                                label="Getchkd User"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                    <MenuItem value={item.getChkdID}>
                                        {item.email}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.getChkdID && <FormHelperText style={{ color: "red" }} >{errors.getChkdID}</FormHelperText>}

                        </FormControl>

                    </Grid>}
                    {values.hasOwnProperty("username") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="username"
                                label="User Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.username}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl>
                    </Grid>
                    }


                    {values.hasOwnProperty("secret") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="secret"
                                label="Secret"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.secret}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl>
                    </Grid>
                    }


                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: '20px' }}
                            disabled={isSubmitting}>
                            {isSubmitting &&
                                <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                        </Button>
                        <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                    </Grid>

                </Grid>
            </Form>
        </>
    )

}
export default AssetLocationForm;